

import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ManageProfile() {
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState("");
  const [mobile_no, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [aadhaar_no, setAadhaar] = useState("");
  const [pan_no, setPan] = useState("");
  const [referral_code, setReferral] = useState("");
    const [bank_name, setBankName] = useState("");
      const [ifsc_code, setifsc_code] = useState("");
        const [account_number, setaccount_number] = useState("");
          const [account_holder_name, setholderName] = useState("");

  const [qrFile, setQrFile] = useState(null);
  const [qrPreview, setQrPreview] = useState("");
  const [savedQr, setSavedQr] = useState("");

  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    if (qrFile) {
      setQrPreview(URL.createObjectURL(qrFile));
    }
  }, [qrFile]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user) {
      setName(user?.name || "");
      setMobile(user?.mobile_no || "");
      setEmail(user?.email || "");
      setAadhaar(user?.aadhaar_no || "");
      setPan(user?.pan_no || "");
      setReferral(user?.referral_code || "");
      setBankName(user?.bank_name || "");
      setifsc_code(user?.ifsc_code || "");
      setaccount_number(user?.account_number || "");
      setholderName(user?.account_holder_name || "");
    }

    fetchQr();
  }, []);

  const fetchQr = async () => {
    try {
      const res = await axios.get(
        "https://api.statixtrading.in/api/admin/qr"
      );

      if (res.data?.qr_image) {
        setSavedQr(
          `https://api.statixtrading.in/uploads/${res.data.qr_image}?t=${Date.now()}`
        );
      }
    } catch (error) {
      console.log("FETCH QR ERROR:", error);
    }
  };

  const handleQrUpload = async () => {
    if (!qrFile) {
      return toast.error("Select QR first");
    }

    const formData = new FormData();

    formData.append("qr_image", qrFile);

    try {
      const res = await axios.post(
        "https://api.statixtrading.in/api/admin/upload-qr",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("QR Uploaded Successfully");

      setSavedQr(
        `https://api.statixtrading.in/uploads/${res.data.image}?t=${Date.now()}`
      );

      setQrFile(null);
      setQrPreview("");
    } catch (error) {
      console.log("UPLOAD ERROR:", error);
      toast.error("Upload Failed");
    }
  };

  const handleUpdate = async () => {
    try {
      setLoading(true);

      const user = JSON.parse(localStorage.getItem("user"));


      const res = await axios.put(
  "https://api.statixtrading.in/api/admin/update-profile",
  {
    name,
    mobile_no,
    email,
    aadhaar_no,
    pan_no,
    referral_code,
    bank_name,
    ifsc_code,
    account_number,
  account_holder_name
  },
  {
    headers: {
      "x-mobile-no": user.mobile_no,  
    },
  }
);

      toast.success(
        res.data.message || "Updated Successfully"
      );

      const updatedUser = {
        ...user,
        name,
        mobile_no,
        email,
        aadhaar_no,
        pan_no,
        referral_code,
           bank_name,
    ifsc_code,
    account_number,
  account_holder_name
      };

      localStorage.setItem(
        "user",
        JSON.stringify(updatedUser)
      );

      setEditMode(false);
    } catch (err) {
      console.log(err);

      toast.error(
        err?.response?.data?.message || "Failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg,#eef2ff,#f8fafc,#ffffff)",
        padding: isMobile ? "12px" : "30px",
      }}
    >
      <ToastContainer
        position="top-center"
        autoClose={3000}
      />

      <div
        style={{
          maxWidth: "1400px",
          margin: "auto",
        }}
      >
        <div
          style={{
            marginBottom: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            flexWrap: "wrap",
            gap: "12px",
          }}
        >
          <h1
            style={{
              color: "#1e293b",
              fontWeight: "700",
              fontSize: isMobile
                ? "24px"
                : "30px",
              margin: 0,
              textAlign: "center",
            }}
          >
            Manage Profile
          </h1>

          <div
            style={{
              position: isMobile
                ? "static"
                : "absolute",
              right: 0,
              background:
                "rgba(255,255,255,0.7)",
              backdropFilter: "blur(10px)",
              border:
                "1px solid rgba(255,255,255,0.5)",
              padding: "12px 18px",
              borderRadius: "18px",
              boxShadow:
                "0 10px 30px rgba(0,0,0,0.06)",
            }}
          >
            <span
              style={{
                fontWeight: "600",
                color: "#111827",
              }}
            >
              Admin Panel
            </span>
          </div>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(320px,1fr))",
            gap: "24px",
                alignItems: "start",
          }}
        >
          <div
            style={{
              background:
                "rgba(255,255,255,0.75)",
              backdropFilter: "blur(14px)",
              border:
                "1px solid rgba(255,255,255,0.4)",
              borderRadius: "30px",
              padding: isMobile
                ? "18px"
                : "35px",
              boxShadow:
                "0 15px 40px rgba(0,0,0,0.08)",
                 alignSelf: "start", 
            }}
          >
            <div
              style={{
                marginBottom: "28px",
              }}
            >
              <h2
                style={{
                  margin: 0,
                  fontSize: isMobile
                    ? "22px"
                    : "26px",
                  color: "#111827",
                  fontWeight: "700",
                }}
              >
                Profile Information
              </h2>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  "repeat(auto-fit,minmax(220px,1fr))",
                gap: "22px",
              }}
            >
              <ProfileItem
                label="Name"
                value={name}
                setValue={setName}
                edit={editMode}
              />

              <ProfileItem
                label="Mobile Number"
                value={mobile_no}
                setValue={setMobile}
                edit={editMode}
              />

              <ProfileItem
                label="Email Address"
                value={email}
                setValue={setEmail}
                edit={editMode}
              />

              <ProfileItem
                label="Password"
                value={aadhaar_no}
                setValue={setAadhaar}
                edit={editMode}
              />

              <ProfileItem
                label="Platform Fees"
                value={pan_no}
                setValue={setPan}
                edit={editMode}
              />

              <ProfileItem
                label="Referral Code"
                value={referral_code}
                setValue={setReferral}
                edit={editMode}
              />

              
              <ProfileItem
                label="Bnak Name"
                value={bank_name}
                setValue={setBankName}
                edit={editMode}
              />

              
              <ProfileItem
                label="IFSC Code"
                value={ifsc_code}
                setValue={setifsc_code}
                edit={editMode}
              />

              
              <ProfileItem
                label="Account NO."
                value={account_number}
                setValue={setaccount_number}
                edit={editMode}
              />

              
              <ProfileItem
                label="Account Holder Name"
                value={account_holder_name}
                setValue={setholderName}
                edit={editMode}
              />
            </div>

            <div
              style={{
                marginTop: "15px",
                display: "flex",
                gap: "14px",
                flexWrap: "wrap",
                width: "100%",
              }}
            >
              {!editMode ? (
                <button
                  onClick={() =>
                    setEditMode(true)
                  }
                  style={primaryBtn(isMobile)}
                >
                  Edit Profile
                </button>
              ) : (
                <>
                  <button
                    onClick={handleUpdate}
                    disabled={loading}
                    style={successBtn(isMobile)}
                  >
                    {loading
                      ? "Updating..."
                      : "Save Changes"}
                  </button>

                  <button
                    onClick={() =>
                      setEditMode(false)
                    }
                    style={dangerBtn(isMobile)}
                  >
                    Cancel
                  </button>
                </>
              )}
            </div>
          </div>

          <div
            style={{
              background:
                "rgba(255,255,255,0.75)",
              backdropFilter: "blur(14px)",
              border:
                "1px solid rgba(255,255,255,0.4)",
              borderRadius: "30px",
              padding: isMobile
                ? "18px"
                : "35px",
              boxShadow:
                "0 15px 40px rgba(0,0,0,0.08)",
              display: "flex",
              flexDirection: "column",
              // justifyContent: "space-between",
            }}
          >
            <div>
              <div
                style={{
                  marginBottom: "2px",
                  textAlign: "center",
                }}
              >
                <h2
                  style={{
                    margin: 0,
                    fontSize: isMobile
                      ? "22px"
                      : "26px",
                    color: "#111827",
                    fontWeight: "700",
                  }}
                >
                  QR Upload
                </h2>
              </div>

              <div
                style={{
                  width: "100%",
                  maxWidth: "100%",
                  // aspectRatio: "1/1",
                  height: isMobile ? "220px" : "280px",
                  margin: "auto",
                  borderRadius: "28px",
                  overflow: "hidden",
                  background:
                    "linear-gradient(135deg,#f8fafc,#eef2ff)",
                  border:
                    "2px dashed #cbd5e1",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow:
                    "inset 0 4px 12px rgba(0,0,0,0.05)",
                }}
              >
                {qrPreview ? (
                  <img
                    src={qrPreview}
                    alt="QR Preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : savedQr ? (
                  <img
                    src={savedQr}
                    alt="Saved QR"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      color: "#94a3b8",
                    }}
                  >
                    <p
                      style={{
                        margin: 0,
                        fontSize: "15px",
                      }}
                    >
                      No QR Uploaded
                    </p>
                  </div>
                )}
              </div>
            </div>

            <div
              style={{
                marginTop: "15px",
              }}
            >
              <input
                type="file"
                accept="image/*"
                onChange={(e) =>
                  setQrFile(
                    e.target.files[0]
                  )
                }
                style={{
                  width: "100%",
                  padding: "12px",
                  border:
                    "1px solid #dbe2ea",
                  borderRadius: "16px",
                  background: "#fff",
                  marginBottom: "16px",
                  boxSizing: "border-box",
                }}
              />

              <button
                onClick={handleQrUpload}
                style={{
                  width: "100%",
                  background: "#858080",
                  color: "#fff",
                  padding: "15px",
                  border: "none",
                  borderRadius: "18px",
                  cursor: "pointer",
                  fontWeight: "700",
                  fontSize: "15px",
                  boxShadow:
                    "0 10px 20px rgba(17,24,39,0.18)",
                }}
              >
                Upload QR
              </button>
            </div>
          </div>
          
        </div>


      </div>
    </div>
  );
}

const ProfileItem = ({
  label,
  value,
  setValue,
  edit,
}) => (
  <div>
    <label
      style={{
        display: "block",
        marginBottom: "8px",
        color: "#6b7280",
        fontSize: "14px",
        fontWeight: "600",
      }}
    >
      {label}
    </label>

    {edit ? (
      <input
        value={value}
        onChange={(e) =>
          setValue(e.target.value)
        }
        style={{
          width: "100%",
          maxWidth: "100%",
          padding: "14px",
          border: "1px solid #d1d5db",
          borderRadius: "14px",
          outline: "none",
          fontSize: "15px",
          background: "#fff",
          boxSizing: "border-box",
        }}
      />
    ) : (
      <div
        style={{
          background: "#f8fafc",
          padding: "14px",
          borderRadius: "14px",
          color: "#111827",
          fontWeight: "500",
          minHeight: "52px",
          display: "flex",
          alignItems: "center",
          border: "1px solid #e5e7eb",
          wordBreak: "break-word",
        }}
      >
        {value || "-"}
      </div>
    )}
  </div>
);

const primaryBtn = (isMobile) => ({
  background: "#4b9be6",
  color: "#fff",
  padding: "13px 24px",
  border: "none",
  borderRadius: "16px",
  cursor: "pointer",
  fontWeight: "700",
  fontSize: "15px",
  width: isMobile ? "100%" : "auto",
  boxShadow:
    "0 10px 20px rgba(37,99,235,0.25)",
});

const successBtn = (isMobile) => ({
  background: "#a8a6a6",
  color: "#fff",
  padding: "13px 24px",
  border: "none",
  borderRadius: "16px",
  cursor: "pointer",
  fontWeight: "700",
  fontSize: "15px",
  width: isMobile ? "100%" : "auto",
  boxShadow:
    "0 10px 20px rgba(34,197,94,0.25)",
});

const dangerBtn = (isMobile) => ({
  background:
    "linear-gradient(135deg,#dc2626,#ef4444)",
  color: "#fff",
  padding: "13px 24px",
  border: "none",
  borderRadius: "16px",
  cursor: "pointer",
  fontWeight: "700",
  fontSize: "15px",
  width: isMobile ? "100%" : "auto",
  boxShadow:
    "0 10px 20px rgba(239,68,68,0.22)",
});

export default ManageProfile;